/**
 * The slider arrow directions
 */
const DIRECTIONS = {
    BACK: -1,
    NEXT: 1
};

/**
 * Everything below this number shouldn't be considered as s swipe.
 * @type {number}
 */
const SWIPE_THRESHOLD = 10;

/**
 * Everything higher this angle in degrees shouldn't be considered as s swipe.
 * @type {number}
 */
const SWIPE_ANGLE_DEG_THRESHOLD = 15;

export {
    DIRECTIONS,
    SWIPE_THRESHOLD,
    SWIPE_ANGLE_DEG_THRESHOLD
};
